export const TOUR_ID = 'in_course_ux';

export const WELCOME_STEP = {
  order: 0,
  title: 'New Course Experience Updates!',
  text: 'We’ve been busy implementing your feedback and making it even easier and faster for you to study on Wizeprep.',
};
export const OVERVIEW_STEP = {
  order: 1,
  title: 'Course Overview',
  text: 'This is the new course overview page where you can find:\n- Your course progress\n- Course notes\n- And any additional content for the course',
};
export const ASSESSMENT_OVERVIEW_STEP = {
  order: 2,
  title: 'Exam Overview Page',
  text: 'This is your exam overview page where you can find all the content we’ve specially prepared for that exam.',
};

export const GRADE_BOOSTER_PAGES_STEP = {
  order: 3,
  title: 'Grade Boosters',
  text: 'Here you can find all the details about the Grade Boosters we’ve prepared for your course and easily access your purchased content.',
};
export const EXAM_BREAKDOWN_STEP = {
  order: 4,
  title: 'Exam Breakdown',
  text: 'All your lessons and practice questions are organized by your exams so you can study only what you need.',
};
export const SEARCH_STEP = {
  order: 5,
  title: 'Search',
  text: 'Search has moved here. Quickly find the topics you want to study.',
};
export const BOOKMARKS_STEP = { order: 6, title: 'Bookmarks', text: 'Your bookmarked lessons have moved here.' };
export const COURSE_SWITCH_STEP = {
  order: 7,
  title: 'Course Switch',
  text: 'Now you can easily switch between your courses.',
};
export const MODES_STEP = {
  order: 8,
  title: 'Practice/Learn Modes',
  text: 'Switch between learn and practice modes here.',
};
export const LESSON_EXPERIENCE_UPDATES_STEP = {
  order: 9,
  title: 'Expand the exam sections to access your lesson content. We’ve made improvements there too!',
  text: ' Expand the exam sections to access your lesson content. We’ve made improvements there too!',
};
export const ORIENTATION_STEP = {
  order: 10,
  title: 'Orientation',
  text: 'The orientation button has moved here. Switch it up to see your videos in theater or column mode.',
};
